import { isAxiosError } from 'axios';

export const STALE_CHANGE_REQUEST_MESSAGE =
  'This Change Request has been updated in another tab or by another user. Refresh the page to load the latest version before saving again.';

const DEFAULT_SAVE_ERROR_MESSAGE = 'Unable to save changes. Please try again.';

function getNonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

function getApiResponseMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) {
    return undefined;
  }

  const responseData = error.response?.data;
  const responseDataMessage = getNonEmptyString(responseData);
  if (responseDataMessage) {
    return responseDataMessage;
  }

  if (responseData && typeof responseData === 'object') {
    const data = responseData as {
      message?: unknown;
      Message?: unknown;
      detail?: unknown;
      title?: unknown;
    };

    return (
      getNonEmptyString(data.message) ??
      getNonEmptyString(data.Message) ??
      getNonEmptyString(data.detail) ??
      getNonEmptyString(data.title)
    );
  }

  return undefined;
}

export function getSaveErrorMessage(
  error: unknown,
  isChangeRequest: boolean,
  defaultMessage = DEFAULT_SAVE_ERROR_MESSAGE
): string {
  if (
    isChangeRequest &&
    isAxiosError(error) &&
    error.response?.status === 409
  ) {
    return STALE_CHANGE_REQUEST_MESSAGE;
  }

  return getApiResponseMessage(error) ?? defaultMessage;
}
